import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  AuthRoutes,
  authProviders
} from './auth/auth.route';
import { CanDeactivateGuard } from './auth/services/can-deactivate-guard.service';
import { AuthGuard } from './auth/services/auth-guard.service';
import { PageNotFoundComponent } from './common/components/pagenotfound.component';
const appRoutes: Routes = [
  { path: 'login', loadChildren: 'js/_build/site/auth/auth.module#AuthModule' },
  { path: 'verify', loadChildren: 'js/_build/site/authverify/authverify.module#AuthVerifyModule', canActivate: [AuthGuard] },
  { path: 'oauth', loadChildren: 'js/_build/site/oauthverify/oauthverify.module#OAuthVerifyModule' },
  { path: 'forgot', loadChildren: 'js/_build/site/auth/forgot.module#ForgotModule' },
  { path: 'reset', loadChildren: 'js/_build/site/auth/reset.module#ResetModule' },
  { path: 'auth', loadChildren: 'js/_build/site/auth/auto.module#AutoModule' },
  { path: 'contact-us', loadChildren: 'js/_build/site/auth/contact.module#ContactModule' },
  { path: '', loadChildren: 'js/_build/site/common/layout.module#LayoutModule' },
  
  { path: '**', component: PageNotFoundComponent },
  
];
export const appRoutingProviders: any[] = [
  authProviders,
  CanDeactivateGuard
];
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);